import React , { useEffect, useState } from "react"
import SelezionaProdSezione from "../../prodotti/SelezionaProdSezione.js"
import QuestionModal from "../../riutilizabili/QuestionModal"
import funzioniRicorrenti from "../../riutilizabili/funzioniRiccorrenti"
import Tabella from "../../riutilizabili/Tabella"
import InputForm from "../../riutilizabili/forms/InputForm"
import FormError from "../../riutilizabili/FormError"
import ImgTabella from "../../prodotti/ImgTabella"
import { daCentEu, daEuCent } from "../../riutilizabili/daEurCent"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleExclamation, faList, faTrash } from "@fortawesome/free-solid-svg-icons"
import TableSemp from "../../riutilizabili/TableSemp"
import parseInputFloatValue from "../../riutilizabili/forms/parseInputFloatValue.js"
import classSezione from "../../fetch/classSezione.js"
import create_autocompleteWithService from "../../riutilizabili/create_autocompleteWithService.js"
import SelectForm from "../../riutilizabili/forms/SelectForm.js"
import ViewProdPopUp from "../../prodotti/ViewProdPopUp.js"
import InfoModal from "../../riutilizabili/InfoModal.js"
import SelezionaProdSituazioneDisp from "../../ProdSituazione/SelezionaProdSituazioneDisp.js"
import CodiciForms from "../sezioni/CodiciForms2.js"
import SwitchOr from "../../riutilizabili/forms/SwitchOr.js"
import CodiciForms2 from "../sezioni/CodiciForms2.js"
import prodSituazione_fetch from "../../fetch/prodSituazione_fetch.js"
import funzioniDdtUscita from "./funzioniDdtUscita.js"


export default function ProdottiBollaUscita({
    onChange,
    inputs,
    errors ,
}) {
    const [arrayProds , setArrayProds] = useState([])
    const [viewSelectProds , setViewSelectProds] = useState(false)
    const [selectProds , setSelectProds] = useState([])
    const [arrayUnitaMisura , setArrayUnitaMisura] = useState([])
    const [mostraSeriali , setMostraSeriali] = useState(false) ;

    const [countRigaCodici , setCountRigaCodici] = useState({})
    const [codici , setCodici] = useState({})

    const [ProdSerialiOn, setProdSerialiOn] = useState({});
    const [errorsProd , setErrorsProd]= useState({});

    useEffect(()=> {
        editSerialiProdUscta()
    },[])

    useEffect(()=> {
        if (inputs?.prods) {
           //console.log(inputs.prods , ' inputs.prods');
            
            setSelectProds(inputs.prods)
        }
    },[inputs,selectProds])

    useEffect(()=>{
        calcTotFattura()
        getUnMisura()
        //console.log('entro b');
    },[inputs?.prods])

   //console.log(inputs , ' inputs DettagliPagamento');

    const editSerialiProdUscta = async () => {
       //console.log('qui editSerialiProdUscta');
        
        const prods = inputs?.prods || []
        let codice = {}
        let righe = {}
       //console.log(prods , ' prods');
        
        prods.forEach(element => {
           //console.log(element , ' ProdSerialis');
            
            if (element?.ProdSerialis) {
                // element.ProdSerialis.forEach((cod, key) => {
                //     if (cod?.seriale) {
                //         codice[cod.prodSezioneId + 'S' + parseInt(key)] = cod.seriale;
                //     }
                //     if (cod?.provisioning) {
                //         codice[cod.prodSezioneId + 'P' + parseInt(key)] = cod.provisioning;
                //     }
                //     if (!righe[cod.prodSezioneId]) {
                //         righe[cod.prodSezioneId] = {}
                //     }
                //     righe[cod.prodSezioneId][parseInt(key)] =1
                    
                // });
                for (let index = 0; index < Object.keys(inputs.prodSeriali).length; index++) {
                    const element = Object.keys(inputs.prodSeriali)[index];
                    if (inputs.prodSeriali[element].length != 0) {
                        setProdSerialiOn(values => ({ ...values, [element]: true }))
                        //setProdSerialiOn(values => ({ ...values, [element.substring(1 , element.length)]: true }))
                    }
                }
            }
           
        });
        // setCountRigaCodici(righe)
        // setCodici(codice)
    }

    const calcTotFattura = async () => {
        let totale = 0;
        let totaleIvato = 0;
        let totaleIva = 0;
        if (!!inputs?.prods) {
            for (let index = 0; index < inputs.prods.length; index++) {
                const element = inputs.prods[index];
                totale += element.prezzoUnitarioCent*element.quantita;

                let prezzoUnitarioMil = element.prezzoUnitarioCent*10
               //console.log(prezzoUnitarioMil , ' prezzoUnitarioMil');
                let iva = ((prezzoUnitarioMil/100)*element.iva)*element.quantita
               //console.log('totale iva : ', iva);
                totaleIva += iva
                let prezzoUnitarioMilIvato = (prezzoUnitarioMil*element.quantita) +iva
               //console.log(prezzoUnitarioMilIvato , ' prezzoUnitarioMilIvato');
                totaleIvato += prezzoUnitarioMilIvato
                //console.log(element.prezzoUnitarioCent);
            }
        }
        //onChange('totFatturaCent', totale)
        const totFatturaCent = funzioniRicorrenti.arrotondaNumero(totaleIvato/1000 , 5)
        const totPagCent = funzioniRicorrenti.arrotondaNumero(totaleIvato/1000 , 5)
        const imponibileCent = funzioniRicorrenti.arrotondaNumero(totale/100 , 5)
        const impostaCent = funzioniRicorrenti.arrotondaNumero(totaleIva/1000 , 5) 
        onChange('totFatturaCent', totFatturaCent+'' )
        onChange('totPagCent',totPagCent+'' )
        onChange('imponibileCent',imponibileCent+'' )
        onChange('impostaCent', impostaCent+'' )
        
       //console.log(totaleIvato/1000 , totaleIva/1000 ,totale);

    }


    const cambiaPrezzo = (prodotto , valoreNew) => {
        const posizioneProd = selectProds.indexOf(prodotto);
        //console.log(posizioneProd , ' posizioneProd');
        let tpm = [...selectProds]
        tpm[posizioneProd].prezzoUnitarioCent = daEuCent(valoreNew)+'' ;
        tpm[posizioneProd].prezzoUnitario = valoreNew+'' ;
        setSelectProds(tpm)
        onChange('prods',tpm)
    }

    const cambiaQt = async (prodotto , valoreNew ) => {
        //console.log(prodotto , valoreNew);

        if (valoreNew) {
           ////console.log(prodotto , valoreNew  , ' prodotto , valoreNew , quantitaResidua');
           if (valoreNew != 0) {
                let query = {
                    prodottoId : prodotto.prodottoId,
                    sezioneId : prodotto.sezioneId,
                }
                if (prodotto.id) {
                    query.id = prodotto.id
                }
                let qtMax = await prodSituazione_fetch.readQtMaxProd(query)
                qtMax =qtMax.data.qtMax
               //console.log(qtMax , ' qtMax');
                
               const posizioneProd = selectProds.indexOf(prodotto);
             // //console.log(posizioneProd , ' posizioneProd');
               let tpm = [...selectProds]
               // tpm[posizioneProd].quantita = quantitaResidua ;
             // //console.log(tpm ,' tpm[posizioneProd].quantita');
            //console.log(prodotto , parseInt(valoreNew), ' prodotto.qta , parseInt(valoreNew)' , !prodotto.qta);
             
               if ((parseInt(valoreNew)<= qtMax)) {
                   tpm[posizioneProd].quantita = parseInt(valoreNew) ;
                   setSelectProds(tpm)
                   onChange('prods',tpm)
                   let tmpError = {...errorsProd}
                   delete tmpError['quantita'+(prodotto.id || prodotto.prodottoId)]
                   setErrorsProd(tmpError)
               }else {
                   setErrorsProd({['quantita'+(prodotto.id || prodotto.prodottoId)] : 'Quantità non disponibile'})
               }
           }
            
        }
        
    }
    //console.log(inputs , ' inputs');
    
    const selezionaProdotto = (value)=>{
       //console.log(value , ' selezionaProdotto value' ,selectProds ,selectProds.map(prod =>prod.pid) ,value.id || value.pid);
        
        const idProd = selectProds.map(prod =>prod.pid)
        const posizioneSeEsiste = idProd.indexOf(value.id || value.pid)
        const myProdSeriali = { ...inputs.prodSeriali };
        
        if (posizioneSeEsiste === -1) {
            myProdSeriali['P' + value.prodottoId] = [];
            let tpm = {...value}
            tpm.quantita = 1
            tpm.pid = tpm.id
            delete tpm.id
            tpm.nomeUnitaMisura = value?.Prodotti?.infoUnitaMisura?.nome

            if (inputs?.anRicarico) {
                let prezzoUnitarioCent = parseInt(value?.Prodotti?.costoCent)+((parseInt(value?.Prodotti?.costoCent)/100)*parseFloat(inputs.anRicarico))
                tpm.prezzoUnitarioCent = prezzoUnitarioCent
                tpm.prezzoUnitario = daCentEu(prezzoUnitarioCent)
            }else {
                tpm.prezzoUnitarioCent = value?.Prodotti?.prezzoVenditaCent
                tpm.prezzoUnitario = daCentEu(value?.Prodotti?.prezzoVenditaCent)
            }
            const prod = funzioniDdtUscita.calcPrezzoVendita(inputs?.anRicarico , tpm)
            setSelectProds(values => ([...values, prod]));
            onChange('prods',[...selectProds ,prod])
        }else {
            myProdSeriali['P' + (value.id || value.pid)] = [];
            let tpm = [...selectProds]
            tpm.splice(posizioneSeEsiste, 1)
            setSelectProds(tpm)
            onChange('prods', tpm)
        }
        onChange('prodSeriali', myProdSeriali);
    }

    const cambiaRicarico = ( prodotto , valore) =>{
        let valoreNew = parseInputFloatValue({value : valore})
       //console.log(valoreNew , 'valoreNew');
        if (!!valoreNew) {
            let tpm = [...selectProds]
           //console.log(tpm , ' tpm')
            const posizioneProd = tpm.indexOf(prodotto);
            let info = tpm[posizioneProd]?.infoProd ? tpm[posizioneProd].infoProd : tpm[posizioneProd].Prodotti
           //console.log(tpm[posizioneProd] , 'tpm[posizioneProd] ' , !!tpm[posizioneProd]?.infoProd);
            
            tpm[posizioneProd].ricarico = valoreNew ;
           //console.log(tpm[posizioneProd].infoProd                ,' tpm[posizioneProd][info]' , info);
            const prezzoConRicarico =info.costoCent +((info.costoCent * parseFloat(valoreNew))/100)
            //const prezzoConRicarico =tpm[posizioneProd].costoCent +((tpm[posizioneProd].costoCent * parseFloat(valoreNew))/100)
            tpm[posizioneProd].prezzoUnitarioCent = prezzoConRicarico * parseInt(tpm[posizioneProd].quantita)
            tpm[posizioneProd].prezzoUnitario = daCentEu(prezzoConRicarico * parseInt(tpm[posizioneProd].quantita))
            setSelectProds(values => ([...values, tpm]));
            onChange('prods', tpm)
        } else {
            let tpm = []
           //console.log(selectProds, 'selectProds');

            selectProds.forEach(element => {
                let temp = {...element} ;
               //console.log(temp , ' temp');
                const ricarico = parseFloat(!!temp?.ricarico ? temp?.ricarico : (!!inputs?.anRicarico ?  parseFloat(inputs?.anRicarico) : 0))
               //console.log(ricarico , ' ricaricoricarico' , temp.prezzoUnitarioCent);
                 
                const prezzoConRicarico = (temp.prezzoUnitarioCent || temp.prezzoUnitarioCent === 0 ) ? (temp.prezzoUnitarioCent +((temp.prezzoUnitarioCent * ricarico)/100)) : (temp.Prodotti.infoProd.costoCent +((temp.Prodotti.infoProd.costoCent * ricarico)/100))
                temp.prezzoUnitarioCent = prezzoConRicarico * parseInt(temp.quantita)
                temp.prezzoUnitario = daCentEu(prezzoConRicarico * parseInt(temp.quantita))
                if (temp.id === prodotto.id ) {
                    temp.ricarico = valoreNew;
                }
                tpm.push(temp)
            });
            // const posizioneProd = tpm.indexOf(prodotto);
            ////console.log(tpm[posizioneProd] , posizioneProd , ' tpm[posizioneProd]');
            // tpm[posizioneProd].ricarico = valoreNew;
            //setSelectProds(values => ([...values, tpm]));
            onChange('prods', tpm)
        }

    }

    const cambiaPrezzoProd = (prodotto , valoreNew) => {
       //console.log(valoreNew );
        
            let tpm = [...selectProds];
            const posizioneProd = tpm.indexOf(prodotto);
            tpm[posizioneProd].prezzoUnitario = parseInputFloatValue({value : valoreNew});
            if (valoreNew === '') {
                tpm[posizioneProd].prezzoUnitarioCent = ''
            } else {
                tpm[posizioneProd].prezzoUnitarioCent = daEuCent(parseInputFloatValue({value : valoreNew})) ===0 ? '0' : daEuCent(parseInputFloatValue({value : valoreNew}));     
            }
            onChange('prods', tpm)
        
    }

    const cambiaIvaProd = (prodotto , valoreNew) => {
       //console.log(valoreNew );
        
            let tpm = [...selectProds];
           //console.log(tpm ,' tpm');
            
            const posizioneProd = tpm.indexOf(prodotto);
            tpm[posizioneProd].iva = parseInputFloatValue({value : valoreNew});
            onChange('prods', tpm)
        
    }

    const getUnMisura = async () => {
        const array = await classSezione.getUnMisura()
       //console.log(array.data , ' array.data');
        setArrayUnitaMisura(array.data)
    }

   //console.log(arrayUnitaMisura , ' arrayUnitaMisura');

    const onChangeUmId = (prodotto , valore) => {
        let tpm = [...selectProds];
        const posizioneProd = tpm.indexOf(prodotto);
        tpm[posizioneProd].umId = parseInt(valore)
        onChange('prods', tpm)
    }
    
    const colonne = [
        {
            label: 'Codice interno',
            nome: 'rifInterno',
            altCol : (original)=> original?.Prodotti?.rifInterno || original?.rifInterno
        },
        {
            label: 'EAN',
            nome: 'ean',
            altCol : (original)=> original?.Prodotti?.ean || original?.ean
        },
        {
            label: 'Descrizione breve',
            nome: 'descrizioneBreve',
            altCol : (original)=> {
                return(
                    <ViewProdPopUp
                        icona={original?.Prodotti?.descrizioneBreve || original?.descrizioneBreve}
                        prodAnId={original?.prodottoId}
                    />
                )
            }
        },
        {
            label: 'Sezione',
            nome: 'infoSezione',
            altCol : (original)=> {
                //console.log(original , 'original');
                return(
                    <span className=" p-0 m-0">
                        {original?.Sezioni?.nome || original?.infoSezione?.nome}
                    </span>
                )
            }
        },
        {
            label: 'Codice a barre',
            nome: 'codBarre',
            altCol : (original)=> {
                //console.log(original , 'original');
                return(
                    <span className=" p-0 m-0">
                        {original?.Prodotti?.codBarre || original?.codBarre}
                    </span>
                )
            }
        },
        {
            label: 'Ricarico (%)',
            nome: 'ricarico',
            altCol : (original)=> {
               //console.log(original , 'original ricarico');
                return(
                    <span className=" p-0 m-0">
                        {/* <input
                            name={'ricarico'}
                            type='text'
                            value={!!original?.ricarico ? original?.ricarico : (!!inputs?.anRicarico ?  parseFloat(inputs?.anRicarico) : 0)}
                            onChange={(event)=> cambiaRicarico(original , event.target.value)}
                            className="rounded h-100 w-50 text-center"
                        /> */}
                        <InputForm
                            label=' '
                            name={'ricarico'}
                            placeholder=''
                            type='text'
                            value={original?.ricarico}
                            onChange={(nome , valore)=> cambiaRicarico(original ,valore)}
                            className="rounded h-100 w-50 text-center form-control "
                            errors={{}}
                        />
                 
                    </span>
                )
            }
        },
        {
            label: 'Prezzo non ivato',
            nome: 'prezzoUnitario',
            altCol : (original)=> {
               //console.log(original , 'original ricarico');
                return(
                    <span className=" p-0 m-0">
                        {/* <input
                            name={'prezzoUnitario'}
                            type='number'
                            defaultValue={'0'}
                            value={original?.prezzoUnitarioCent/100}
                            onChange={(event)=> cambiaPrezzoProd(original , event.target.value)}
                            className="rounded h-100 w-50 text-center"
                        /> */}
                        <InputForm
                            label=' '
                            name={'prezzoUnitario'}
                            placeholder=''
                            type='text'
                            value={original?.prezzoUnitario}
                            onChange={(nome , valore)=> cambiaPrezzoProd(original ,valore)}
                            className="rounded h-100 w-50 text-center form-control "
                            errors={{}}
                        />
                    </span>
                )
            }
        },
        {
            label: 'IVA',
            nome: 'iva',
            altCol : (original)=> {
               //console.log(original , 'original');
            return(
                <span className="p-0 m-0" >
                    <InputForm
                        label=' '
                        name={'iva'}
                        placeholder=''
                        type='text'
                        value={original?.iva}
                        onChange={(nome , valore)=> cambiaIvaProd(original ,valore)}
                        className="rounded h-100 w-50 text-center form-control "
                        errors={{}}
                    />
                </span>
            )
        }
        },
        // {
        //     label: "Seriali",
        //     nome: 'Seriali',
        //     altCol : (item)=> {
        //        //console.log(item , 'item');
        //         return(
        //             <>
        //                 <button className="btn" onClick={()=>setMostraSeriali(item)} >
        //                     <FontAwesomeIcon icon={faList} />
        //                 </button>
        //             </>
        //         )
        //     }
        // },
        {
            label: 'Quantità',
            nome: 'quantita',
            altCol : (original)=> {
             //  //console.log(original , 'original f' ,original?.prezzoVendita);

                const min = calcQtMin(original.id || original.prodottoId)

               //console.log(min , ' calcQtMincalcQtMin');
                
                return(
                    <div>

                    {original?.quantita >=0 &&<input
                            name={'quantita'}
                            type='number'
                            defaultValue={'0'}
                            value={!!original?.quantita ? original?.quantita : 0}
                            max={!!original?.qta && original?.qta }
                            onChange={(event)=> cambiaQt(original , event.target.value)}
                            className="rounded h-100 w-100 text-center form-control mt-5"
                            min={min}
                            style={{width : '2rem'}}
                        />}
                        {errorsProd?.['quantita'+(original.id || original.prodottoId)] &&<FontAwesomeIcon className="ms-3 fs-5 text-danger" icon={faCircleExclamation} title='Quantità non disponibile'/>}
                        
                       {Object.keys(errorsProd).length >0 && <FormError errors={errorsProd} classi=' col-12 d-block ' field={'quantita'+(original.id || original.prodottoId)} />}
                        <FormError errors={errors} field={'quantita'} />
                    </div>
                )
            }
        },
        {
            label : 'Unità di misura',
            nome: 'umId',
            altCol : (original)=> {
               //console.log(original.umId , ' original.umId');
                
                return <div className=' m-2'>
                {!!original?.umId && <SelectForm
                    arrayElement={arrayUnitaMisura}
                    value={original.umId}
                    name='umId'
                    onChange={(nome , valore)=>onChangeUmId(original , valore)}
                    errors={[]}
                />}
            </div>
            }
        },
        {
            label: 'Elimina',
            nome: 'Elimina',
            altCol : (original)=> {
                return(
                    <>
                        <button onClick={()=>selezionaProdotto(original)} className="btn text-danger p-0">
                            <FontAwesomeIcon icon={faTrash} />
                        </button>
                    </>
                )
            }
        }

    ]

    const calcQtMin = (prodId) => {
        if (ProdSerialiOn[prodId] && inputs?.prodSeriali.length) {
           //console.log(inputs?.prodSeriali['P'+prodId] , " inputs?.prodSeriali['P'+prodId]" , inputs?.prodSeriali['B'+prodId]);
            if (inputs?.prodSeriali['P'+prodId] || inputs?.prodSeriali['B'+prodId]) {
                if (inputs?.prodSeriali['B'+prodId]) {
                    return inputs?.prodSeriali['B'+prodId].length
                }else {
                    
                    return inputs?.prodSeriali['P'+prodId].length
                }
            }else{
                return 1 
            }
        } else {
            return 1
        }
    }

   //console.log(inputs , ' inputs');

    const deleteCodice = (codice) => {
       //console.log(codice, ' codice deleteCodice');

        let tmp = { ...inputs.codici }
        delete tmp[codice]

        onChange('codici', tmp)
    }

   //console.log(countRigaCodici ,' countRigaCodici');
   //console.log(codici , 'codici');
   console.log(inputs?.prods , 'inputs?.prods');
    
    return(
        <div  className="border border-primary border-3 p-3 rounded-4 m-3 ">
            <div className="d-flex flex-wrap align-items-center ms-4 mt-5">
                {/* <button className="btn btn-primary me-4" onClick={()=>setViewSelectProds(true)} >Seleziona Articoli</button> */}
                <SelezionaProdSituazioneDisp
                    prodsIds={selectProds.map(item => item.pid)}
                    classiBtn={' btn-primary '}
                    iconButton='Seleziona articoli'
                    selezionaProdotto={selezionaProdotto}
                    magazzinoId={inputs?.magazzinoId}
                    inputs={inputs}
                />
                <p className="p-0 m-0 text-danger fst-italic" >*Selezionare almeno un articolo per salvare </p>
            </div>


            {/* <Tabella
                data={selectProds}
                columns={columns}
            /> */}
            <TableSemp
                colonne={colonne}
                dati={selectProds}
                infoAdd={
                    <div className="col-12 my-5 d-flex justify-content-end" >
                        <div className=" btn btn-primary h-100 m-2 ms-4">Imponibile : € {(inputs?.imponibileCent/100).toFixed(2).replace('.', ',')} </div>
                        <div className="col-2 btn btn-primary h-100 m-2 ms-4">Imposta : € {(inputs?.impostaCent/100).toFixed(2).replace('.', ',')} </div> 
                        <div className="col-2 btn btn-primary h-100 m-2 ms-4">Importo : € {(inputs?.totFatturaCent/100).toFixed(2).replace('.', ',')} </div> 
                    </div>
                }
                  secondaRiga={ (item) => {
                   //console.log(item , 'item seriali');

                    const chiave = item.id ? 'B' + item.id : 'P' + item.prodottoId;
                   //console.log(inputs.prodSeriali , ' inputs.prodSeriali');
                    
                    const myProdSeriali = inputs.prodSeriali[chiave] ;

                    return (
                        // <CodiciForms item={item} onChange={onChange} prods={inputs?.prods} errors={errors} />
                        <td colSpan="11">
                            <SwitchOr
                                stato={ProdSerialiOn[chiave]}
                                name={chiave}
                                label='Seriali'
                                onChangeValue={(stato, id) => {
                                    if (inputs?.prodSeriali[chiave].length === 0) {
                                        setProdSerialiOn(values => ({ ...values, [chiave]: stato }))
                                    }
                                }}
                                width={'10rem'}
                                classe=' mt-5 '
                                disabled={inputs?.prodSeriali[chiave]?.length != 0}
                            />
                            <div className="ms-4">

                            {!!ProdSerialiOn[chiave] &&
                                <CodiciForms2
                                    onChange={(key, nome, valore) => {
                                        const allProdSeriali = { ...inputs.prodSeriali };
                                        const elemento = allProdSeriali[chiave][key] ? { ...allProdSeriali[chiave][key] } : { };
                                        elemento[nome] = valore;
                                        allProdSeriali[chiave][key] = elemento;
                                        onChange('prodSeriali', allProdSeriali);
                                    }}
                                    onDelete={(key)=> {
                                        const allProdSeriali = { ...inputs.prodSeriali };
                                        const seriali = allProdSeriali[chiave]

                                        const nuoviSeriali = []

                                        for (let index = 0; index < seriali.length; index++) {
                                            const element = seriali[index];
                                            if (index != key) {
                                                nuoviSeriali.push(element)
                                            }
                                        }
                                        allProdSeriali[chiave] = nuoviSeriali
                                       //console.log(nuoviSeriali , ' nuoviSeriali');
                                        
                                        onChange('prodSeriali', allProdSeriali);
                                        if (item.quantita != 1) {
                                            cambiaQt(item , item.quantita-1)
                                        }

                                    }}
                                    prodSeriali={myProdSeriali}
                                    item={item}
                                    exonChange={(nome, codici) => onChange('codici', { ...inputs?.codici, ...codici })}
                                    prods={inputs?.prods}
                                    errors={errors}
                                    codice={inputs?.codici}
                                    deleteCodice={deleteCodice}
                                />}
                                <div className="col-12 ps-4 ms-3 mb-3">
                                    <FormError errors={errors} field={'seriale'+chiave} />
                                    <FormError errors={errors} field={'provisioning'+chiave} />
                                </div>
                            </div>
                        </td>
                    )
                }}
            />
            <FormError errors={errors} field='prodotti' />

            {viewSelectProds &&<QuestionModal
                title={'Seleziona articolo dal '+inputs?.magazzinoNome+inputs?.tipoMag !== 'Magazzino' ? (' - Magazzino ti tipo '+inputs?.tipoMag ) :'' }
                text={
                    <SelezionaProdSezione magazzinoId={inputs?.magazzinoId} prodIdSelezionati={selectProds.map(item => item.id)} onChange={selezionaProdotto} />
                }
                onClose={()=>{setViewSelectProds(false); cambiaRicarico(false , false) }}
                classi={'modal-xxl'}
            />}

            {!!mostraSeriali && 
             <InfoModal
                size='xl'
                title={'Seriali articolo '+mostraSeriali.nome+' - '+mostraSeriali.rifInterno}
                text={
                    <div>
                        {mostraSeriali.ProdSerialis.length > 0 ?
                        <ul>
                            {mostraSeriali.ProdSerialis.map((item , key) => {
                                return(
                                    <li>
                                        {item.seriale}
                                    </li>
                                )
                            })}
                        </ul>
                        :
                        <div>
                            Nessun seriale presente
                        </div>
                        }
                    </div>
                }
                canClose={true}
                handleClose={()=>setMostraSeriali(false)}
             />
            }

        </div>
    )
}
